export class PrivatePaymentClient {
  private worker = new Worker(
    new URL("./private-send.worker.ts", import.meta.url),
    { type: "module" },
  );
  private next = 1;
  private closed = false;
  private pending = new Map<
    number,
    { resolve: (value: any) => void; reject: (error: Error) => void }
  >();
  constructor(onProgress?: (message: string) => void) {
    this.worker.onmessage = ({ data }) => {
      const request = this.pending.get(data.id);
      if (request && typeof data.progress === "string") {
        onProgress?.(data.progress);
        return;
      }
      if (request) {
        this.pending.delete(data.id);
        data.ok
          ? request.resolve(data.value)
          : request.reject(new Error(data.error));
      }
    };
    const failed = () => {
      this.closed = true;
      this.worker.terminate();
      this.fail(
        "Private wallet worker failed. Retry preparation. Encrypted recovery data is preserved.",
      );
    };
    this.worker.onerror = failed;
    this.worker.onmessageerror = failed;
  }
  request(method: string, payload: unknown = {}): Promise<any> {
    if (this.closed) return Promise.reject(new Error("Wallet session closed."));
    return new Promise((resolve, reject) => {
      const id = this.next++;
      this.pending.set(id, { resolve, reject });
      this.worker.postMessage({ id, method, payload });
    });
  }
  private fail(message: string) {
    for (const request of this.pending.values())
      request.reject(new Error(message));
    this.pending.clear();
  }
  close() {
    this.closed = true;
    this.worker.terminate();
    this.fail("Wallet session closed.");
  }
}
